export function usePriceFormatter() {
    const formatPrice = (price, curency) => {
        const locales = {
            NOK: 'nb-NO',
            SEK: 'sv-SE',
            EUR: 'en-IE',
        };

        const locale = locales[curency];

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: curency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(price);
    }

    return { formatPrice };
}
